import { render } from "./NavLink.vue?vue&type=template&id=61864e79&scoped=true"
import script from "./NavLink.vue?vue&type=script&lang=js"
export * from "./NavLink.vue?vue&type=script&lang=js"

import "./NavLink.vue?vue&type=style&index=0&id=61864e79&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-61864e79"

export default script